<template>
	<CDialog
		:visible="visible"
		title="Remove Payment Method?"
		custom-class="dialog--narrow"
		@done="$emit('close')"
	>
		<p>
			All credit card data will be removed.
			<span v-show="isTrial">When your trial ends, you will be placed on the free Individual plan.</span>
		</p>
		<p>Are you sure you want to remove your payment method?</p>
		<template #footer>
			<button
				class="c-modal-button c-modal-button-cancel button--secondary"
				@click="$emit('close')"
			>
				Cancel
			</button>
			<CStatusButton
				:status="status"
				class="c-modal-button button--primary"
				@click="status = 'validating'; $emit('delete')"
			>
				Remove
			</CStatusButton>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import CStatusButton from 'src/components/interaction/StatusButton.vue';

	export default defineComponent({
		name: 'CDeleteBillingInfoDialog',
		components: {
			CDialog,
			CStatusButton
		},
		props: {
			visible: { type: Boolean, default: false },
			isTrial: { type: Boolean, required: true }
		},
		data() {
			return {
				status: 'default'
			};
		}
	});
</script>